import { useTranslation } from "@/hooks/useTranslation"
import { Filter } from "@/organisms/FilterNew/Filter"
import { InputSmartSearchLoading, SmartSearch } from "@/organisms/SmartSearch"
import { useAiPolicyAgentOptions } from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies"
import { getDecisionsFilters } from "./getDecisionsFilters"

import type { FilterDecisionsTabProps } from "./FilterDecisionsTab.types"

// The decisions' filter bar, kept in the query string the API is asked with
export const FilterDecisionsTab = ({
  policies,
  arePoliciesLoading
}: FilterDecisionsTabProps) => {
  const { t } = useTranslation()
  const agents = useAiPolicyAgentOptions()
  const isLoading = agents.isLoading || arePoliciesLoading
  const filters = getDecisionsFilters(t, { policies, agents: agents.options })

  return (
    <Filter.Provider isLoading={isLoading}>
      <Filter.Template
        isLoading={isLoading}
        search={
          isLoading ? (
            <InputSmartSearchLoading />
          ) : (
            <SmartSearch id="FilterAiPolicyDecisions" filters={filters} />
          )
        }
      />
    </Filter.Provider>
  )
}
